import { create } from 'zustand';
import debounce from 'lodash/debounce';

interface NavigationState {
  isOpen: boolean;
  scrolled: boolean;
  isTransitioning: boolean;
  setIsOpen: (isOpen: boolean) => void;
  setScrolled: (scrolled: boolean) => void;
  setIsTransitioning: (isTransitioning: boolean) => void;
  toggleMenu: () => void;
  handleScroll: () => void;
}

export const useNavigationStore = create<NavigationState>()((set) => {
  // Create debounced scroll handler
  const debouncedScrollHandler = debounce(() => {
    set({ scrolled: window.scrollY > 20 });
  }, 100);

  return {
    isOpen: false,
    scrolled: false,
    isTransitioning: false,
    setIsOpen: (isOpen) => {
      set({ isOpen });
      // Handle body overflow
      document.body.style.overflow = isOpen ? 'hidden' : '';
    },
    setScrolled: (scrolled) => set({ scrolled }),
    setIsTransitioning: (isTransitioning) => {
      set({ isTransitioning });
      if (isTransitioning) {
        setTimeout(() => {
          set({ isTransitioning: false });
          document.body.classList.remove('page-transition');
        }, 300);
      }
    },
    toggleMenu: () => set((state) => ({ isOpen: !state.isOpen })),
    handleScroll: () => debouncedScrollHandler(),
  };
}); 